module.exports = __webpack_public_path__ + "static/media/hand.9a950e42.svg";